/**
 * Client-side stable chat id, minted in the browser when the UI creates a chat.
 *
 * Sending a client-minted id in the create POST lets the server's idempotent
 * create-by-id collapse any duplicate/retried create (React StrictMode
 * double-invoke, a double-click, or a re-render) onto a single chat row instead
 * of spawning orphan empty "Entity Chat" rows.
 *
 * Format mirrors the entity-chat route's own fallback (`entity-chat-<ts>-<rand>`)
 * so a client-minted id is indistinguishable from a server-minted one
 * downstream. Deliberately dependency-free (no `uuid`) to keep it cheap in the
 * client bundle and trivially loadable in jsdom tests.
 */
export function generateClientChatId(): string {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 10);
  return `entity-chat-${timestamp}-${random}`;
}
